import { TStoreWithClear } from '~/types/store';

class ClearStore {
  storesToClearOnLogout: TStoreWithClear[] = [];

  addStoreToClear<T extends TStoreWithClear>(store: T) {
    this.storesToClearOnLogout.push(store);
  }

  clear() {
    this.storesToClearOnLogout.forEach((store) => {
      store.clear();
    });
  }
}

export const clearStore = new ClearStore();
